module.exports = __webpack_public_path__ + "static/media/teamsInvite.3e1d560f.svg";